<div class="column">
    <h2>Questionari globali - Numero medio di questionari per paziente</h2>
    <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
      <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
        <canvas id = "myChartAverageQuestionnairesPerPatient"></canvas>
      </div>
    </div>
  </div>